export default function renderCalendar(date, month) {
  date.setDate(1);
  const monthDays = document.querySelector(`#days-${month}`);

  const lastDay = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0
  ).getDate();

  const prevLastDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    0
  ).getDate();

  let firstDayIndex = date.getDay() - 1;

  const months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

  document.querySelector(`#month-${month} h1`).innerHTML = `${months[date.getMonth()]} ${date.getFullYear()}`;

  let days = "";

  if(firstDayIndex === -1) firstDayIndex = 6;
  for (let x = firstDayIndex; x > 0; x--) {
    if(new Date(date.getFullYear(),date.getMonth(),0).getDay() === 0) break;
    days += `<div class="prev-date">${prevLastDay - x + 1}</div>`;
  }

  for (let i = 1; i <= lastDay; i++) {
    days += `<div>${i}</div>`;
  }
  monthDays.innerHTML = days;
};
